import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import iconsMixin from '../../core/dtwin/state/bridge/iconsMixin';
import { isEqual } from 'lodash';
var PAYLOAD = "{\n    \"jobName\": \"{{exportTitle}}\",\n    \"date\": \"{{exportDate}}\",\n    \"fileDownloadLink\": \"{{downloadLink}}\"\n}";
export default {
  name: 'CSVForwardToThirdParty',
  mixins: [iconsMixin],
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          selectedOutboundConnector: null,
          payload: PAYLOAD
        };
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    outboundConnectors: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      internalModel: _objectSpread({}, this.value)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    validJson: function validJson() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }, function (v) {
        try {
          JSON.parse(v);
          return true;
        } catch (error) {
          return _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.invalidJson');
        }
      }];
    },
    hasOutboundConnectors: function hasOutboundConnectors() {
      return this.outboundConnectors && this.outboundConnectors.length;
    },
    validPayload: function validPayload() {
      try {
        JSON.parse(this.internalModel.payload);
        return true;
      } catch (error) {
        return false;
      }
    }
  }),
  watch: {
    internalModel: {
      handler: function handler() {
        this.emitInput();
      },
      deep: true
    },
    value: {
      handler: function handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = _objectSpread({}, this.value);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (!this.internalModel.payload) {
      this.internalModel.payload = PAYLOAD;
    }

    this.emitInput();
  },
  methods: {
    emitInput: function emitInput() {
      this.$emit('input', _objectSpread(_objectSpread({}, this.internalModel), {}, {
        formIsValid: this.internalModel.selectedOutboundConnector && this.validPayload
      }));
    }
  }
};